import React from "react";
import { useEffect, useState } from "react";
import "./Bills.css";
import BillList from "../../components/BillList/BillList";
import Typography from "@mui/joy/Typography";
import Loading from "../Loading";
import Background from "../../hero-pattern.svg";
import debounce from 'lodash/debounce';
import { Stack } from "@mui/joy";

function Bills() {
  const [bills, setBills] = useState([]); // Store the list of bills
  const [lastKey, setLastKey] = useState(null); // Store the last evaluated key for pagination
  const [loading, setLoading] = useState(false); // Loading state
  const [hasMore, setHasMore] = useState(true); // Whether there are more bills to load
  const [searchParams, setSearchParams] = useState({
    keyword: "",
    state: 'FD'
  }); // Search parameters

  const fetchBills = async (reset = false) => {
    if (loading || (!hasMore && !reset)) return;
    setLoading(true);
    if (reset) setBills([]);

    try {
      await fetch(
        "/api/bill?" +
          new URLSearchParams({
            keyword: searchParams.keyword,
            state: searchParams.state,
            limit: 20,
            lastKey: reset ? null : JSON.stringify(lastKey),
          }).toString()
      )
        .then((response) => {
          var json = response.json();
          return json;
        })
        .then((data) => {
          const { items, lastKey: newLastKey } = data;
          setBills((prevBills) => (reset ? items : [...prevBills, ...items])); // Reset or append
          setLastKey(newLastKey); // Update the last evaluated key
          setHasMore(!!newLastKey); // If there's no newLastKey, we've reached the end
        });
    } catch (err) {
      console.error("Error fetching bills:", err);
    } finally {
      setLoading(false);
    }
  };

  // Handle search form submission
  const handleSearch = (e) => {
    e.preventDefault();
    fetchBills(true); // Reset the results and fetch new ones
  };

  // Infinite scrolling
  const handleScroll = debounce(() => {
    if (
      window.innerHeight + document.documentElement.scrollTop >=
      document.documentElement.offsetHeight - 100
    ) {
      fetchBills();
    }
  }, 200); // Debounce with a 200ms delay

  // Fetch bills on component mount
  useEffect(() => {
    document.title = 'Bills & Legislation | Civic Engage';
    fetchBills(); // Fetch bills when the component loads
  }, []); // Empty dependency array ensures this runs only once

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastKey, hasMore]);

  return (
    <Stack
      className="hero-image"
      direction={"column"}
      sx={{
        alignItems: 'stretch',
        backgroundImage: "url(" + Background + ")"
      }}
    >
      {loading && bills.length === 0 ? (
        <Loading></Loading>
      ) : (
        <>
          <Stack direction={"column"} padding={8} spacing={1}>
            <Stack direction={"column"} spacing={1}>
              <Typography level="h1" style={{ textAlign: "center" }}>
                Empowerment Through Information
              </Typography>
              <Typography level="body-lg" style={{ textAlign: "center" }}>
                Get the latest on upcoming legislation and advocate for what you
                believe in!
              </Typography>
            </Stack>
          </Stack>
          <BillList
            bills={bills}
            loading={loading}
            hasMore={hasMore}
            setSearchParams={setSearchParams}
            searchParams={searchParams}
            handleSearch={handleSearch}
          />
        </>
      )}
    </Stack>
  );
}

export default Bills;
